import { formatAgentStatus, formatPaymentStatus, formatPlan, formatProvider, formatSubscriptionStatus } from '../lib/copy';

type StatusKind = 'plan' | 'agent' | 'payment' | 'provider' | 'subscription' | 'generic';

function labelFor(status: string, kind: StatusKind): string {
  switch (kind) {
    case 'plan':
      return formatPlan(status);
    case 'agent':
      return formatAgentStatus(status);
    case 'payment':
      return formatPaymentStatus(status);
    case 'provider':
      return formatProvider(status);
    case 'subscription':
      return formatSubscriptionStatus(status);
    default:
      return formatPaymentStatus(status);
  }
}

export function StatusBadge({
  status,
  kind = 'generic',
  className,
}: {
  status: string;
  kind?: StatusKind;
  className?: string;
}) {
  const normalized = status.toLowerCase();
  const tone =
    normalized === 'active' || normalized === 'completed' || normalized === 'paid' || normalized === 'pro'
      ? 'bg-ops-success-soft text-ops-success'
      : normalized === 'pending' || normalized === 'processing' || normalized === 'paused'
        ? 'bg-ops-warning-soft text-ops-warning'
        : normalized === 'failed' || normalized === 'cancelled' || normalized === 'revoked'
          ? 'bg-ops-danger-soft text-ops-danger'
          : 'bg-ops-surface-muted text-ops-secondary';

  return (
    <span
      className={['inline-flex rounded-pill px-2.5 py-0.5 text-xs font-medium', tone, className]
        .filter(Boolean)
        .join(' ')}
    >
      {labelFor(status, kind)}
    </span>
  );
}
